import { Tab } from "@mui/material";
import { useEffect, useState } from "react";
import { DashboardIcon, GraphIcon } from "src/components/icons/NavIcons";
import { HinnatIcon } from "src/components/icons/StepIcons";
import MyTabs from "src/components/layout/MyTabs/MyTabs";
import { useStatData } from "src/context/StatContext";
import { useUserData } from "src/context/userContext";
import Stat_Dashboard from "../../Dashboard/Stat_Dashboard";
import Stat_StatisticsChart1 from "../../components/Stat_StatisticsChart1";
import Stat_Hintalaskelmat from "../../components/Stat_Hintalaskelmat";
import YearMonthDropDownWithButton from "src/components/YearMonthDropDown/YearMonthDropDownWithButton";
import Stat_Kustannuspaikat from "../../components/Stat_Kustannuspaikat";
import Stat_pumppari from "../../components/Stat_pumppari/Stat_pumppari";
import { TabPanel } from "src/components/js/Statics";

export default function ReportMonthlyLayout() {
  const { recalcStat } = useStatData();
  const { user, userAsiakas, auth } = useUserData();
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    if (userAsiakas?.auth?.isPumppari) setTabValue(4);
  }, [user, userAsiakas]);

  const handleTabChange = (event, newValue) => setTabValue(newValue);

  return (
    <div>
      <MyTabs value={tabValue} onChange={handleTabChange} centered>
        {auth.page.report.stats.dash.read && (
          <Tab
            value={0}
            label={
              <div className="tab">
                <DashboardIcon /> Dashboard
              </div>
            }
          />
        )}
        {auth.page.report.stats.stat.read && (
          <Tab
            value={1}
            label={
              <div className="tab">
                <GraphIcon /> Tilastot
              </div>
            }
          />
        )}
        {auth.page.admin.read && (
          <Tab
            value={2}
            label={
              <div className="tab">
                <HinnatIcon /> Hintalaskelmat
              </div>
            }
          />
        )}
        {auth.page.report.stats.kustannuspaikat.read && (
          <Tab
            value={3}
            label={
              <div className="tab">
                <HinnatIcon /> Kustannuspaikat
              </div>
            }
          />
        )}
        {auth.page.report.stats.pumppari.read && (
          <Tab
            value={4}
            label={
              <div className="tab">
                <GraphIcon /> Pumpparistats
              </div>
            }
          />
        )}
      </MyTabs>
      <TabPanel value={tabValue} index={0}>
        <Stat_Dashboard />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <Stat_StatisticsChart1 />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <div style={{ width: "100%" }}>
          <Stat_Hintalaskelmat />
          <YearMonthDropDownWithButton
            buttonText="LASKE UUDELLEEN"
            onClick={(year, month) => recalcStat(year, month)}
            buttonProps={{
              variant: "contained", //color: "primary"
            }}
          />
        </div>
      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <Stat_Kustannuspaikat />
      </TabPanel>
      <TabPanel value={tabValue} index={4}>
        <Stat_pumppari />
      </TabPanel>
    </div>
  );
}
